import React from 'react';

import { ErrorBoundary } from '@nxte-nl/error-boundary';
import { stateHooks } from '@nxte-nl/state-hooks';

import { Arrow } from '../icons';
import styles from './ScrollUpButton.module.css';

export type UseScrollUpButtonData = {
  isScrollUpButtonVisible: boolean;
};

export const hooks = {
  useScrollUpButton() {
    const {
      value: isScrollUpButtonVisible,
      setValue: setIsScrollUpButtonVisible,
    } = stateHooks.useBooleanState({ initialState: false });

    const handleScrollDeps:(((arg: boolean) => void) | number)[] = [
      setIsScrollUpButtonVisible,
    ];
    typeof window !== 'undefined' && handleScrollDeps.push(window.scrollY);
    typeof screen !== 'undefined' && handleScrollDeps.push(screen.height);

    const handleScroll = React.useCallback(() => {
      setIsScrollUpButtonVisible(window.scrollY > 2 * screen.height);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, handleScrollDeps);

    React.useEffect(()=> {
      window.onscroll && window.removeEventListener('scroll', handleScroll);
      window.addEventListener('scroll', handleScroll, true);
      return window.removeEventListener('scroll', handleScroll);
    }, [handleScroll]);

    return {
      isScrollUpButtonVisible,
    };
  },

  useHandleClick() {
    return React.useCallback(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, []);
  },
};

export const ScrollUpButton = React.memo(() => {
  const { isScrollUpButtonVisible } = hooks.useScrollUpButton();

  const handleClick = hooks.useHandleClick();

  return (
    <>
      <ErrorBoundary>
        {isScrollUpButtonVisible
        && <div
          className={styles.scrollUpButton}
          onClick={handleClick}
        >
          <Arrow fill='var(--midnight-purple)' variant='up'/>
        </div>
        }
      </ErrorBoundary>
    </>
  );
});

ScrollUpButton.displayName = 'ScrollUpButton';
